import React from 'react';
import { UploadImagesStep, ReviewBudgetStep, InvoiceStep, PreviewStep } from '../shared/steps';
import { SectionsStep } from './sections';
import {
  DOCUMENT_STATIC_SECTION_IDS,
  PAYAPP_STATIC_SECTION_IDS,
  DOCUMENT_SUBSTEPS,
  PAYAPP_SUBSTEPS,
  REVIEW_BUDGET_SUBSTEPS,
} from './sections/section-utils';

export interface WizardSubStepConfig {
  id: string;
  title: string;
}

export interface WizardStepConfig {
  id: string;
  title: string;
  component?: React.ReactNode;
  subSteps?: WizardSubStepConfig[];
}

export const MAGIC_REPORT_BASE_STEPS: WizardStepConfig[] = [
  { id: 'upload-images', title: 'Photos', component: <UploadImagesStep /> },
  {
    id: 'review-budget',
    title: 'Review Budget',
    component: <ReviewBudgetStep />,
    subSteps: [...REVIEW_BUDGET_SUBSTEPS],
  },
  {
    id: 'payapp-review',
    title: 'Payapp Review',
    component: <SectionsStep staticSectionIds={PAYAPP_STATIC_SECTION_IDS} showCoverLetterAmounts />,
    subSteps: [...PAYAPP_SUBSTEPS],
  },
  {
    id: 'document-review',
    title: 'Document Review',
    component: <SectionsStep staticSectionIds={DOCUMENT_STATIC_SECTION_IDS} showRecapOfPreviousReports />,
    subSteps: [...DOCUMENT_SUBSTEPS],
  },
  { id: 'invoice', title: 'Invoice', component: <InvoiceStep showExportAll service='Construction Monitoring' /> },
  { id: 'preview', title: 'Preview', component: <PreviewStep /> },
];

export const MAGIC_REPORT_SCROLL_SPY_STEP_IDS = new Set(['review-budget', 'payapp-review', 'document-review']);

export const PAYAPP_REVIEW_STEP_INDEX = MAGIC_REPORT_BASE_STEPS.findIndex(step => step.id === 'payapp-review');
export const DOCUMENT_REVIEW_STEP_INDEX = MAGIC_REPORT_BASE_STEPS.findIndex(step => step.id === 'document-review');
